import * as authTypes from './authTypes';

const initialState = {
  token: '',
  isAuthenticated: false,
  staff: {},
  loading: false,
  error: null,
  otpSent: false,
  getClinic: [],
  selectedClinic: [],
};

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case authTypes.SET_AUTH_STAFF:
      return { ...state, isAuthenticated: true, staff: payload.staff };

    case authTypes.RESTORE_SESSION:
      const token = localStorage.getItem('token');
      return { ...state, isAuthenticated: !!token, token: token || '' };

    case authTypes.SEND_OTP_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.SEND_OTP_SUCCESS:
      return { ...state, loading: false, otpSent: true };

    case authTypes.SEND_OTP_FAILURE:
      return { ...state, loading: false, error: payload.payload };

    case authTypes.LOGIN_WITH_OTP_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.LOGIN_WITH_OTP_SUCCESS:
      return { ...state, loading: false, isAuthenticated: true, token: payload.payload };

    case authTypes.LOGIN_WITH_OTP_FAILURE:
      return { ...state, loading: false, error: payload.payload };

    case authTypes.GET_CLINIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getClinic: payload.payload?.data || payload.data || payload.payload || [],
      };
    case authTypes.GET_CLINIC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.payload?.error || payload.error,
      };

    case authTypes.SET_SELECTED_CLINIC:
      return {
        ...state,
        selectedClinic: payload.payload || payload,
      };


    default:
      return state;
  }
};
